import React from "react";
import { Cascader, Button, Input, Segmented } from "antd";
import { InfoCircleOutlined } from '@ant-design/icons';

const CollectionToolbar = ({
  filterOptions,
  appliedFilters,
  onChangeFilter,
  onApplyFilters,
  mobileNumber,
  onSearchCustomer,
  onChangeNumberSearch,
  sortSelector,
  setSortSelector,
  totalEntries,
  tableLoader,
  filterCascader
}) => {
  return (
    <>
      {/* Top row */}
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
        <div style={{ display: "flex", gap: 10, flex: 1 }}>
          <Cascader
            style={{ width: "30%" }}
            value={appliedFilters}
            options={filterOptions}
            onChange={onChangeFilter}
            multiple
            disabled={tableLoader}
            showCheckedStrategy={Cascader.SHOW_CHILD}
            showSearch={{ filter: filterCascader }}
            placeholder="Filter by"
          />

          <Button type="primary" onClick={onApplyFilters} disabled={tableLoader}>
            Apply
          </Button>
        </div>

        <Input.Search
          disabled={tableLoader}
          allowClear
          placeholder="enter phone number"
          enterButton
          style={{ width: "30%" }}
          value={mobileNumber}
          onSearch={onSearchCustomer}
          onChange={(e) => onChangeNumberSearch(e.target.value)}
        />
      </div>

      {/* Bottom row */}
      <div style={{ display: 'grid', gridTemplateColumns: 'auto auto auto', alignItems: 'center', marginTop: 20 }}>
        <div>
          <span style={{ fontSize: "small", color: "grey", paddingRight: 5 }}>
            Sort by Paid At
          </span>

          <Segmented
            disabled={tableLoader}
            options={["oldest first", "newest first"]}
            value={sortSelector}
            onChange={setSortSelector}
          />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', width: 'fit-content' }}>
          <div style={{ fontSize: 'small', color: 'grey' }}>( showing {totalEntries ? totalEntries.toLocaleString('en-IN') : 0} entries )</div>
          <InfoCircleOutlined style={{ marginLeft: '5px', color: 'grey' }} />
        </div>
      </div>
    </>
  );
};

export default CollectionToolbar;